import { lazy } from 'react'

const Home = lazy(() => import('./Home'))
const Profile = lazy(() => import('./Profile'))
const Auth = lazy(() =>
  import('./Auth').then(module => ({ default: module.Auth }))
)
const AuthGoogle = lazy(() =>
  import('./Auth').then(module => ({ default: module.AuthGoogle }))
)
const ResetPassword = lazy(() => import('./ResetPassword'))
const CustomerList = lazy(() =>
  import('./Customer').then(module => ({ default: module.CustomerList }))
)
const CustomerDetails = lazy(() =>
  import('./Customer').then(module => ({ default: module.CustomerDetails }))
)
const ValidateEmail = lazy(() => import('./ValidateEmail'))
const UploadDocuments = lazy(() => import('./secure_link/UploadDocuments'))
const MainIndex = lazy(() => import('./qr_pages/MainIndex'))
const OTPscreen = lazy(() => import('./qr_pages/OTPscreen'))
const MessageScreen = lazy(() => import('./qr_pages/MessageScreen'))

export {
  Home,
  Profile,
  Auth,
  AuthGoogle,
  ResetPassword,
  CustomerList,
  CustomerDetails,
  ValidateEmail,
  UploadDocuments,
  MainIndex,
  OTPscreen,
  MessageScreen
}
